import axios from 'axios';
import { app_version } from './Utils';

export const serverUrl = `${process.env.REACT_APP_SERVER_URL || ''}`;

axios.defaults.baseURL = serverUrl + '/api';
axios.defaults.headers.post['Content-Type'] ='application/json';

const ArthaGateway = {
    validateLogin: async function(userName, password) {
        try {
            const payload = { userName, password };
            let response = await axios.post('/master/party/validate', payload);
            if (response) {
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::validateLogin ->"+ error);
            throw error;
        }
        return false;
    },
    getCompany: async function(companyId) {
        try {
            const params = { id: companyId };
            let response = await axios.get('/company', { params });
            if (response) {
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getCompany ->" + error);
            throw error;
        }
        return undefined;
    },
    getDealers: async function(salesPersonId, reportsToId, name = "", districtId = 0, talukId = 0, pageNumber = 1, pageSize = 10, dealerType = 0, activeOnly = true) {
        try {
            const params = { salesPersonId, reportsToId, name, talukId, districtId, pageNumber, pageSize, dealerType, activeOnly  };
            let response = await axios.get('/master/dealer', { params });
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getDealers ->"+ error);
            throw error;
        }
        return undefined;
    },
    getBalance: async function(accountId) {
        try {
            let response = await axios.get('/accounting/account/'+ accountId.toString() + '/balance');
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getDealer ->"+ error);
            throw error;
        }
        return undefined;
    },
    getTransactions: async function(accountId, durationId, pageNumber = 1, pageSize = 10) {
        try {
            if(pageNumber <= 0) { 
                pageNumber = 1; 
            }
            const params = { durationId, accountId, pageNumber, pageSize  };
            let response = await axios.get('/accounting/account/'+ accountId + "/transaction", { params });
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getTransactions ->"+ error);
            throw error;
        }
        return undefined;
    },
    getBusinessSummary: async function(partId, durationId) {
        try {
            const params = { durationId  };
            let response = await axios.get('/master/party/businessSummary/'+ partId, { params });
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getTransactions ->"+ error);
            throw error;
        }
        return undefined;
    },
    getSalesPersonBusinessSummary: async function(salesPersonId, durationId) {
        try {
            const params = { salesPersonId, durationId  };
            let response = await axios.get('/master/salesPerson/businessSummary/', { params });
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getSalesPersonBusinessSummary ->"+ error);
            throw error;
        }
        return undefined;
    },
    getSalesPersonOutstandingSummary: async function(salesPersonId, asOn) {
        try {
            const params = { salesPersonId, asOn  };
            let response = await axios.get('/master/salesPerson/outstandingSummary/', { params });
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getSalesPersonOutstandingSummary ->"+ error);
            throw error;
        }
        return undefined;
    },
    getPendingInvoices: async function(partyId) {
        try {
            const params = { partyId  };
            let response = await axios.get('/voucher/sale/pending', { params });
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getPendingInvoices ->"+ error);
            throw error;
        }
        return undefined;
    },
    getSalesperson: async function() {
        try {
            const params = { activeOnly: true, reportsTo: -1  };
            let response = await axios.get('/master/salesPerson', { params });
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getTransactions ->"+ error);
            throw error;
        }
        return undefined;
    },
    getSales: async function(partyId: number, durationId: string, salesPersonId: number, pageNumber: number = 1, pageSize: number = 10) {
        try {
            const params = { partyId, durationId, salesPersonId, aymentType: 0, departmentId: 0, companyId: 0, pageNumber, pageSize, fields: "Id,VoucherNumber,Date,BillAmount,VehicleNumber,DriverName,DriverNumber" };
            let response = await axios.get('/voucher/sale', { params });
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getTransactions ->"+ error);
            throw error;
        }
        return undefined;
    },
    getSalesSummary: async function(partyId: number, durationId: string, salesPersonId: number) {
        try {
            const params = { partyId, durationId, salesPersonId, aymentType: 0, departmentId: 0, companyId: 0  };
            let response = await axios.get('/voucher/sale/summary', { params });
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getTransactions ->"+ error);
            throw error;
        }
        return undefined;
    },
    getReceipts: async function(partyId: number, durationId: string, salesPersonId: number, pageNumber: number = 1, pageSize: number = 10) {
        try {
            const params = { partyId, durationId, salesPersonId, aymentType: 0, departmentId: 0, companyId: 0, pageNumber, pageSize, fields: "Id,VoucherNumber,Date,Amount,PaymentType,ReferenceNumber"  };
            let response = await axios.get('/voucher/receipt', { params });
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getTransactions ->"+ error);
            throw error;
        }
        return undefined;
    },
    getReceiptsSummary: async function(partyId: number, durationId: string, salesPersonId: number) {
        try {
            const params = { partyId, durationId, salesPersonId, aymentType: 0, departmentId: 0, companyId: 0  };
            let response = await axios.get('/voucher/receipt/summary', { params });
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getTransactions ->"+ error);
            throw error;
        }
        return undefined;
    },
    getCreditNotes: async function(partyId: number, durationId: string, salesPersonId: number, pageNumber: number = 1, pageSize: number = 10) {
        try {
            const params = { partyId, durationId, salesPersonId, pageNumber, pageSize  };
            let response = await axios.get('/voucher/creditNote', { params });
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getCreditNote ->"+ error);
            throw error;
        }
        return undefined;
    },
    getCreditNotesSummary: async function(partyId: number, durationId: string, salesPersonId: number) {
        try {
            const params = { partyId, durationId, salesPersonId, aymentType: 0, departmentId: 0, companyId: 0  };
            let response = await axios.get('/voucher/creditNote/summary', { params });
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getCreditNoteSummary ->"+ error);
            throw error;
        }
        return undefined;
    },
    getSalesFileLink: async function(saleId) {
        try {
            let response = await axios.get('/voucher/sale/pdf/'+ saleId);
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getTransactions ->"+ error);
            throw error;
        }
        return undefined;
    },
    getSalesOrderFileLink: async function(salesOrderId) {
        try {
            let response = await axios.get('/voucher/order/pdf/'+ salesOrderId);
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getTransactions ->"+ error);
            throw error;
        }
        return undefined;
    },
    getReceiptFileLink: async function(receiptId) {
        try {
            let response = await axios.get('/voucher/receipt/pdf/'+ receiptId);
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getReceiptFileLink ->"+ error);
            throw error;
        }
        return undefined;
    },
    getCreditNoteFileLink: async function(creditNoteId) {
        try {
            let response = await axios.get('/voucher/creditNote/pdf/'+ creditNoteId);
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getCreditNoteFileLink ->"+ error);
            throw error;
        }
        return undefined;
    },
    getPartyStatementFileLink: async function(accountId, durationId) {
        try {
            const params = { durationId  };
            let response = await axios.get('/accounting/account/statement/pdf/'+ accountId, { params });
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getTransactions ->"+ error);
            throw error;
        }
        return undefined;
    },
    getOutstandingReportFileLink: async function(dealerId) {
        try {
            let response = await axios.get('/master/dealer/outstanding/pdf/'+ dealerId);
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getTransactions ->"+ error);
            throw error;
        }
        return undefined;
    },
    getOrders: async function(partyId: number, durationId: string, salesPersonId: number, deliveryStatus: number, pageNumber: number = 1, pageSize: number = 10) {
        try {
            const params = { partyId, durationId, salesPersonId, deliveryStatus, departmentId: 0, companyId: 0, pageNumber, pageSize, fields: "Id,VoucherNumber,Date,Status,ProductionPlantName" };
            let response = await axios.get('/voucher/order', { params });
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getTransactions ->"+ error);
            throw error;
        }
        return undefined;
    },
    getOrdersSummary: async function(partyId: number, durationId: string, salesPersonId: number, deliveryStatus: number) {
        try {
            const params = { partyId, durationId, salesPersonId, deliveryStatus, departmentId: 0, companyId: 0  };
            let response = await axios.get('/voucher/order/summary', { params });
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getCreditNoteSummary ->"+ error);
            throw error;
        }
        return undefined;
    },
    getCreditNoteEligibality: async function(partyId: number) {
        try {
            const params = { partyId };
            let response = await axios.get('/reports/party/creditNoteEligibality', { params });
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getTransactions ->"+ error);
            throw error;
        }
        return undefined;
    },    
    initiatePayment: async function(partyId, amount) {
        try {
            let redirectionUrl = window.location.origin + "/payment/result";
            const params = { partyId, amount, redirectionUrl  };
            let response = await axios.get('/phonepe/initiate', { params });
            if (response) {  
                console.log(response);
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getTransactions ->"+ error);
            throw error;
        }
        return undefined;
    },    
    processPayment: async function(tid, churn) {
        try {
            const params = { tid, churn  };
            let response = await axios.get('/phonepe/process', { params });
            if (response) {  
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getTransactions ->"+ error);
            throw error;
        }
        return undefined;
    },
    logActivity: async function(activity) {
        try {
            let logActivity = { ...activity, appVersion: app_version }
            let response = await axios.post('/master/dealer/app/activity', logActivity);
            if (response) {  
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::logActivity ->"+ error);
            throw error;
        }
        return undefined;
    },  
    getProductGroups: async function() {
        try {
            let response = await axios.get('/master/product/group');
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getProductGroups ->"+ error);
            throw error;
        }
        return undefined;
    },    
    getProductBrands: async function() {
        try {
            let response = await axios.get('/master/product/brand');
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getProductBrands ->"+ error);
            throw error;
        }
        return undefined;
    },
    getProductMaster: async function(id) {
        try {
            let response = await axios.get('/master/productMaster/' + id);
            if (response) {
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getProduct ->"+ error);
            throw error;
        }
        return undefined;
    },
    getProductMasters: async function(groupId, brandId, name, activeOnly = true, pageNumber = 1, pageSize = 1000, fields = "Id, Name, ImageUrl") {
        try {
            let params = { groupId, brandId, name, activeOnly, pageNumber, pageSize, fields };
            let response = await axios.get('/master/productMaster', { params });
            if (response) {
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getProductMaster ->"+ error);
            throw error;
        }
    },
    getProducts: async function(groupId, name, pageNumber = 1, pageSize = 20) {
        try {
            let url= '/master/product?type=1&activeOnly=true';
            url += '&name='+ name;
            url += '&groupId='+ groupId;
            url += '&pageNumber='+ pageNumber +'&pageSize='+ pageSize;
            url += '&fields=Id,Name,GroupName,ImageUrl,Price,UnitOfMeasureCode as Unit, Discount, IgstTax.Percentage as TaxPercentage';
            let response = await axios.get(url);
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getProductBrands ->"+ error);
            throw error;
        }
        return undefined;
    },   
    getProductStyles: async function(productMasterId) {
        try {
            let param = { productId: productMasterId };
            let response = await axios.get('/master/product/style/', { params: param });
            if (response) {
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getProductStyles ->"+ error);
            throw error;
        }
        return undefined;
    },
    getProductPricing: async function(partyId, productId) {
        try {
            let url= 'master/party/product/pricing/';
            const params = { partyId, productId  };
            let response = await axios.get(url, { params });
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getProductBrands ->"+ error);
            throw error;
        }
        return undefined;
    },
    saveOrder: async function(order) {
        try {
            let response = await axios.post('/voucher/order', order);
            if (response) {
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::saveOrder ->"+ error);
            throw error;
        }
    },
    getSalesOrders: async function(partyId: number, durationId: string, salesPersonId: number, pageNumber: number = 1, pageSize: number = 10) {
        try {
            const params = { partyId, durationId, salesPersonId, reportsToId: salesPersonId, departmentId: 0, companyId: 0, pageNumber, pageSize  };
            let response = await axios.get('/voucher/order', { params });
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getTransactions ->"+ error);
            throw error;
        }
        return undefined;
    },
    getSalesOrder: async function(orderId: number) {
        try {
            let response = await axios.get('/voucher/order/' + orderId);
            if (response) {
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getSalesOrder ->"+ error);
            throw error;
        }
        return undefined;
    },
    cancelSalesOrder: async function(orderId: number, reason: string, userId: number) {
        try {
            const params = { id: orderId, comment: reason, userId };
            let response = await axios.get('/voucher/order/delete', { params });
            if (response) {
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::deleteSalesOrder ->"+ error);
            throw error;
        }
    },
    getSalesOrderSummary: async function(partyId: number, durationId: string, salesPersonId: number) {
        try {
            const params = { partyId, durationId, salesPersonId, aymentType: 0, departmentId: 0, companyId: 0  };
            let response = await axios.get('/voucher/order/summary', { params });
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getTransactions ->"+ error);
            throw error;
        }
        return undefined;
    },  
    uploadFile: async function(file, folder: string) {
        try {
            const formData = new FormData();
            formData.append('file', file);
            const url = '/document/upload?folder=' + encodeURIComponent(folder);
            let response = await axios.post(url, formData, {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
            });
            if (response) {
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::uploadFile ->"+ error);
            throw error;
        }
    },
     getBankCheques: async function(partyId: number, durationId: string, status: number) {
        try {
            const params = { partyId, durationId, status };
            let response = await axios.get('/accounting/bankCheque', { params });
            if (response) {            
                return response.data;
            }
        } catch (error) {
            console.error("Error in ArthaGateway::getTransactions ->"+ error);
            throw error;
        }
        return undefined;
    },  
}

export default ArthaGateway;